module.exports = __webpack_public_path__ + "media/images/flags/4x3/ukr-41f78cec2f5d49f6c8d13c40c766217b.svg";